import { render, staticRenderFns } from "./data-packaging-page.vue?vue&type=template&id=5f7a3958&scoped=true"
import script from "./data-packaging-page.vue?vue&type=script&lang=js"
export * from "./data-packaging-page.vue?vue&type=script&lang=js"
import style0 from "./data-packaging-page.vue?vue&type=style&index=0&id=5f7a3958&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7a3958",
  null
  
)

export default component.exports